var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M437,75A256,256,0,0,0,75,437,256,256,0,0,0,437,75ZM378.31,195.07,235.24,338.14a15,15,0,0,1-21.21,0l-80.34-80.33a15,15,0,0,1,21.22-21.22l69.72,69.73L357.09,173.86a15,15,0,0,1,21.22,21.21Z"}));
}

Check.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Check;

Check.default = Check;
